import React, { useEffect, useState } from "react";
import { getBreathalyzerModalDailyActivityApi } from "../../../api/api";
import LoadingSpiner from "../../Common/LoadingSpiner";

const DailyActivity = ({ user }) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const today = new Date();
  const month = today.toLocaleString("default", { month: "long" });

  useEffect(() => {
    fetchData();
  }, [user]);

  const fetchData = async () => {
    setLoading(true);
    const res = await getBreathalyzerModalDailyActivityApi(user);
    if (res?.error) {
      Toast.fire({
        icon: "error",
        title: "Something went wrong",
      });
    } else {
      setRecords(res || []);
    }
    setLoading(false);
  };

  return (
    <div className="breathalyzerModal mt-6">
      <div className="flex w-full my-2 px-4 justify-between items-center">
        <p className="text-2xl font-bold font-poppin">Daily Activity</p>
        <p className="text-md pt-1 font-poppin">
          {month} {today.getDate()}, {today.getFullYear()}
        </p>
      </div>
      <hr className="h-0.5 bg-gray-400 border-none my-2" />

      {loading ? (
        <LoadingSpiner loading={loading} />
      ) : records.length === 0 ? (
        <div className="w-[90%] flex justify-center mx-auto">
          <p className="text-center text-gray-500 mt-4">
            No Breathalyzer readings have been recorded for this patient today.
            Please check back later for updates or encourage the patient to
            submit a reading to monitor their BAC levels.
          </p>
        </div>
      ) : (
        <table className="w-full border-collapse border border-black rounded-md">
          <tbody>
            {records.map((record, index) => (
              <tr key={index} className="border border-black">
                <td className="p-2 font-poppin">{record.date}</td>
                <td className="p-2 font-light font-poppin">
                  BAC: {record.bac}
                </td>
                <td className="p-2 font-light font-poppin">
                  AuditC: {record.auditC}
                </td>
                <td className="p-2 font-light font-poppin">
                  Drinks since last reading: {record.drinksSinceLastReading}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default DailyActivity;
